import { TouchPointHelper } from '../../../helpers/touchPointHelper';
import { placeholders, displayGroups } from '@ui';

export const intro = {
	prismName: 'intro',
	template: {
		templateName: 'introTemplate',
		displayGroups: [
			TouchPointHelper.createDisplayGroup(displayGroups.pageContainer, [
				TouchPointHelper.createDisplayGroup(displayGroups.rowContainer, [
					TouchPointHelper.createDisplayGroup(
						displayGroups.leftPanel,
						[],
						[
							TouchPointHelper.createPlaceholder(placeholders.logo, {
								placeholderBuildReference: 10,
							}),
							TouchPointHelper.createPlaceholder(placeholders.introWizard, {
								placeholderBuildReference: 20,
							}),
							TouchPointHelper.createPlaceholder(placeholders.doubtsAndExit, {
								placeholderBuildReference: 200,
							}),
						]
					),
					TouchPointHelper.createDisplayGroup(displayGroups.columnContainer, [
						TouchPointHelper.createDisplayGroup(
							displayGroups.bodyPanel,
							[],
							[
								TouchPointHelper.createPlaceholder(placeholders.intro, {
									placeholderBuildReference: 20,
								}),
							]
						),
					]),
				]),
			]),
		],
	},
};
